var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SnippetHelper } from './SnippetHelper';
import { Utils } from './Utils';
import { DateUtils } from './DateUtils';
import { LanguageHelper } from './LanguageHelper';
var PodcastPageHelper = (function () {
    function PodcastPageHelper() {
    }
    PodcastPageHelper.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var backSnippet, backLinks, i, podcastLinks, podcastLinksHTML, i, podcastLinksDom, embedID, embedDOM, pageTitle, podcastDateDom, podcastDate, cDom, pDom, dateTimestamp, dateHTML;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // get admin snippets for localized text and inject into dom
                        SnippetHelper.locSnippet("#backToPodcasts", "back-text-1");
                        SnippetHelper.locSnippet("#backToPodcasts", "back-text-2");
                        SnippetHelper.locSnippet("#guestInformation", "guest-info");
                        SnippetHelper.locSnippet("#podcastHost", "host-info");
                        SnippetHelper.locSnippet("#tagsHeading", "tags-heading");
                        return [4 /*yield*/, SnippetHelper.getSnippet("#backToPodcasts")];
                    case 1:
                        backSnippet = _a.sent();
                        backLinks = document.querySelectorAll(".back-link");
                        for (i = 0; i < backLinks.length; i++) {
                            if (backSnippet[0].url.url) {
                                backLinks[i].setAttribute("href", backSnippet[0].url.url);
                            }
                        }
                        return [4 /*yield*/, SnippetHelper.getSnippet("#podcastLinks")];
                    case 2:
                        podcastLinks = _a.sent();
                        if (podcastLinks.length > 0) {
                            podcastLinksHTML = "<ul>";
                            for (i = 0; i < podcastLinks.length; i++) {
                                podcastLinksHTML += '<li><a href="' + podcastLinks[i].url.url + '"';
                                if (podcastLinks[i].openNew) {
                                    podcastLinksHTML += ' target="_blank"';
                                }
                                podcastLinksHTML += '><img src="' + podcastLinks[i].snippet + '" alt="' + podcastLinks[i].url.description + '" />' + '</a>';
                            }
                            podcastLinksHTML += "</ul>";
                            podcastLinksDom = document.getElementById("podcast-links");
                            podcastLinksDom.innerHTML = podcastLinksHTML;
                        }
                        embedID = document.getElementById("podcastEmbed").textContent.trim();
                        embedDOM = document.getElementById("podcastPlayer");
                        pageTitle = document.getElementById("pageTitleField") && document.getElementById("pageTitleField").textContent.trim().length > 0 ? document.getElementById("pageTitleField").textContent.trim() : "Podcast player";
                        embedDOM.innerHTML = '<iframe title="' + pageTitle + '" style="border: none" src="//html5-player.libsyn.com/embed/episode/id/' + embedID + '/height/90/theme/custom/thumbnail/yes/direction/backward/render-playlist/no/custom-color/006492/" height="90" width="100%" scrolling="no" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" oallowfullscreen="" msallowfullscreen=""></iframe>';
                        podcastDateDom = document.getElementById("podcastDateDisplay");
                        podcastDate = document.getElementById("podcastDate");
                        cDom = "ttTagsHidden";
                        pDom = "ttTagSection";
                        setTimeout(function () {
                            Utils.tagSectionCheck(cDom, pDom);
                        }, 3000);
                        if (!podcastDate) return [3 /*break*/, 4];
                        return [4 /*yield*/, DateUtils._formatDate(podcastDate.textContent.trim(), LanguageHelper.getCurrentLocale().Locale, "LL")];
                    case 3:
                        dateTimestamp = _a.sent();
                        dateHTML = "<span id='podcastDateStamp'>" + dateTimestamp + "</span>";
                        // write the date to the dom element
                        podcastDateDom.innerHTML = dateHTML;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return PodcastPageHelper;
}());
export { PodcastPageHelper };

//# sourceMappingURL=PodcastPageHelper.js.map
